import DocOverlay from "./DocOverlay"
import { useDocStore } from "./store"

const DocController = () => {
  const onOpenInTab = useDocStore((state) => state.openRemotely)
  const presentation = useDocStore((state) => state.presentation)
  const dismiss = useDocStore((state) => state.dismiss)

  return (
    <DocOverlay
      onOpenInTab={onOpenInTab}
      didClose={dismiss}
      isOpen={!!presentation?.doc}
      doc={presentation?.doc}
      side={presentation?.side}
    />
  )
}

export default DocController
